module.exports = __webpack_public_path__ + "static/media/nailbed.d72ee249.png";